
<section id="howToAddComment" >
  <div class="w-full text-center relative  float-end  h-[360px]" id="mask-image">
    <p class="text-white font-bold text-5xl m-0 pb-2 mb-1   mt-5">
      {{reviewsCount}}
    </p>
    <h2 class="text-white font-bold mt-5">نفر بهترین نکات سفرشون رو به اشتراک گذاشتن</h2>
   
  </div>
  <div class="container lg:px-0 px-2">
    <nav>
      <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2 my-5">
        <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
          *ngFor="let bread of breadcrumb; let last = last; let index = index;let first = first">
          <ng-container *ngIf="!last">
            <a [href]="first ? '/' : bread.Url">
              {{ bread.Name }}
            </a>
          </ng-container>
          <ng-container *ngIf="last">
            <span class=""> {{ bread.Name }} </span>
          </ng-container>
    
        </li>
      </ol>
    </nav>
    <div class="border__right mt-10 mb-3">
      <h3 class="d-inline-block m-0 font-bold">چگونه نظر ثبت می‌شود؟</h3>
    </div>
    <!-- --- -->
    <iho-white-box-border-bottom [boxData]="whiteBoxData" [colNumber]="4"></iho-white-box-border-bottom>
  </div>
</section>
<!-- --- -->
<section id="lastComments" class="mt-20">
  <div class="container lg:px-0">
    <div class="border__right mt-3">
      <h3 class="d-inline-block m-0 font-bold">آخرین نظرات ثبت شده توسط میهمانان در هتل های ایران</h3>
    </div>
    <iho-custom-masonry [reviewsCount]="reviewsCount" [data]="latestReviews" [colClass]="3"
                        [columnCount]="4"></iho-custom-masonry>
  </div>
</section>
<!-- --- -->
<section id="otherComments" class="mt-20">
  <div class="container lg:px-0 px-2">
    <div class="border__right ps-3 mt-3">
      <h3 class="d-inline-block m-0 font-bold">جستجوی نظرات سایر شهرها</h3>
    </div>

    <div class="filterCities mt-10 mb-5">
      <ul class="flex items-center justify-center w-full overflow-x-auto x-scroll">
        <li (click)="setCity(city.Id)" [class.active]="city.IsActive" class="cursor-pointer"
            *ngFor="let city of cities">{{city.Title}}</li>
      </ul>
    </div>

    <div class="searchBoxWrapper">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="searchBox position-relative">
            <input type="text" (keyup)="filterData($event)" placeholder="شهر موردنظر خود را وارد نمائید...">
            <i class="ico_search position-absolute fs-1.5"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 mt-lg-5">
      <iho-custom-masonry [data]="filteredMasonryData" [colClass]="3" [columnCount]="4"></iho-custom-masonry>
    </div>

  </div>
</section>
<section class="mt-10">
  <div class="container lg:px-0 px-2">
    <div class="border__right ps-3 mb-3">
      <h3 class="pr-2 d-inline-block m-0 fw-normal fw-bold">جستجوی نظرات سایر شهرها</h3>
    </div>

    <ul *ngIf="stateCities.length" class="state-cities mt-4 pt-4" >
      <li *ngFor="let item of stateCities" class="province-box" style="background-color: rgb(245, 245, 245) !important">
        <span class="province-title">{{item.StateTitle}}</span>
        <ul *ngIf="item.Cities.length">
          <li *ngFor="let city of item.Cities">
            <a [href]="city.Url">{{'نظرات هتل های '+city.CityTitle}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</section>
